import { SuspenseErrorBoundary } from '@/components/SuspenseErrorBoundary';
import { useBusinessDocument } from '@/context/services/business_document/BusinessDocument.service';
import { BusinessDocumentDetail as BusinessDocumentDetailType } from '@/context/services/business_document/type';
import { BusinessDocumentContent } from '@/features/business_documents/Detail/components/Content/Content';
import { Dispatch, FC, memo, SetStateAction, useEffect } from 'react';
export type Props = {
  id: string;
  onClose: () => void;
  setData: Dispatch<SetStateAction<BusinessDocumentDetailType | null>>;
};

const InnerDetails: FC<Props> = memo(({ id, onClose, setData }) => {
  const { data } = useBusinessDocument(id);

  useEffect(() => {
    if (data) {
      setData(data);
    }
  }, [data, setData]);

  return <BusinessDocumentContent data={data} onClose={onClose} />;
});
InnerDetails.displayName = 'InnerDetails';

export const BusinessDocumentDetail: FC<Props> = memo((props) => {
  return (
    <SuspenseErrorBoundary {...props}>
      <InnerDetails {...props} />
    </SuspenseErrorBoundary>
  );
});

BusinessDocumentDetail.displayName = 'BusinessDocumentDetail';
